import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ClassBannersAvailableCategories from './ClassBannersAvailableCategories'
import ClassBannersActiveBanners from './ClassBannersActiveBanners'
import ClassBannersAddSuccessModal from './ClassBannersAddSuccessModal'

import { selectStepCreateBanner } from '../../../../../../routing/fetchingfunction/user/user.reducer'
import { setCreateBannerStep } from '../../../../../../routing/fetchingfunction/user/user.action'

import { useAvailableCategories } from '../../../../../../hooks'

const ClassBanners = () => {
  const dispatch = useDispatch()

  const step = useSelector(selectStepCreateBanner)

  const { classBannerCategories } = useAvailableCategories()

  const handleCloseSuccessModal = () => {
    dispatch(setCreateBannerStep(1))
  }

  return (
    <div className="w-full">
      <ClassBannersAvailableCategories classBannerCategories={classBannerCategories} />
      <ClassBannersActiveBanners classBannerCategories={classBannerCategories} />

      <ClassBannersAddSuccessModal
        open={step === 3 || step === 4}
        isEdit={step === 4}
        onClose={handleCloseSuccessModal}
      />
    </div>
  )
}

export default ClassBanners
